import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

const Searchbar = ({ field, register }) => {
  return (
    <TextField
      id={field?.name}
      label={field?.label}
      className="filter-input"
      placeholder={field?.placeholder}
      variant="standard"
      InputLabelProps={{ shrink: true }}
      {...register(field?.name)}
      InputProps={{
        disableUnderline: true
      }}
      onKeyDown={(ev) => {
        if (ev.key === 'Enter') {
          ev.preventDefault();
        }
      }}
    />
  );
};

export default Searchbar;

Searchbar.propTypes = {
  field: PropTypes.object,
  register: PropTypes.any
};
